export default __webpack_public_path__ + "static/media/delete-icon.08679cc0.svg";